module.exports = __webpack_public_path__ + "img/9_107.115d79b3.png";